"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../app");
exports.Auth = {
    type() {
        return localStorage.getItem("auth-type") || "";
    },
    mode() {
        if (this.isAdminOnly())
            return require("../app/modes/admin_mode").AdminMode;
        if (this.isWorker())
            return require("../app/modes/worker_mode").WorkerMode;
        return require("../app/modes/client_mode").ClientMode;
    },
    isAdminOnly() {
        return this.type() == "Admin";
    },
    isAdmin() {
        return (this.type() == "Admin") || (this.type() == "Worker");
    },
    isWorker() {
        return this.type() == "Worker";
    },
    isClient() {
        return this.type() == "Client";
    },
    adminOnly(cb) {
        return exports.Auth.isAdmin() ? ((typeof (cb) == "function") ? cb() : cb) : undefined;
    },
    clientOnly(cb) {
        return exports.Auth.isClient() ? ((typeof (cb) == "function") ? cb() : cb) : undefined;
    },
    isImpersonated() {
        return localStorage.getItem("auth-impersonated") === 'yes';
    },
    logout() {
        localStorage.removeItem("auth-token");
        localStorage.removeItem("auth-type");
        localStorage.removeItem("auth-impersonated");
        mithril_1.default.route.set("/sign-in");
    },
    token() {
        return localStorage.getItem("auth-token") || "";
    },
    uriEncodedToken() {
        return encodeURIComponent(this.token());
    },
    impersonate(id) {
        app_1.App.get(`/clients/${id}/impersonate`).then((data) => {
            localStorage.setItem("auth-token", data["token"]);
            localStorage.setItem("auth-type", data["type"]);
            localStorage.setItem("auth-impersonated", 'yes');
            mithril_1.default.route.set("/&");
            window.location.reload();
        });
    },
    stopImpersonate() {
        app_1.App.get('/stop-impersonation').then((data) => {
            localStorage.setItem("auth-token", data["token"]);
            localStorage.setItem("auth-type", data["type"]);
            localStorage.removeItem("auth-impersonated");
            window.location.reload();
        });
    },
    refreshToken() {
        let token = localStorage.getItem("auth-token");
        if (token) {
            mithril_1.default.request({
                method: "GET",
                url: app_1.App.serviceURL("/refresh"),
                headers: { "X-Auth-Token": token }
            }).then((data) => {
                localStorage.setItem("auth-token", data["token"]);
                localStorage.setItem("auth-type", data["type"]);
            }).catch((_err) => {
                this.logout();
            });
        }
        else {
            let route = mithril_1.default.route.get() || "";
            if (!route.match(/reset-password/)) {
                localStorage.removeItem("auth-token");
                mithril_1.default.route.set("/sign-in");
            }
        }
    },
    auth(login) {
        login.error = false;
        mithril_1.default.request({
            method: "POST",
            url: app_1.App.serviceURL("/sign_in"),
            data: {
                email: login.email,
                password: login.password
            }
        }).then((data) => {
            localStorage.setItem("auth-token", data["token"]);
            localStorage.setItem("auth-type", data["type"]);
            login.email = login.password = "";
            mithril_1.default.route.set("&");
            window.location.reload();
        }).catch((err) => {
            login.error = err.code || 501;
            login.errorMessage = err.message;
        });
    }
};
